var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/Accordion/Accordion.tsx
import React2, { useMemo, useState as useState2 } from "react";
import { nanoid } from "nanoid";
import { View } from "vcc-ui";

// src/utils/useControlled.ts
import { useCallback, useState } from "react";
var useControlled = ({
  value: valueProp,
  defaultValue
}) => {
  const isControlled = typeof valueProp === "boolean";
  const [valueState, setValue] = useState(defaultValue || false);
  const value = isControlled ? valueProp : valueState;
  const dummySetValue = useCallback(() => {
  }, []);
  return [value, isControlled ? dummySetValue : setValue];
};

// src/Accordion/AccordionContext.tsx
import { createContext, useContext } from "react";
var AccordionContext = createContext(void 0);
var useAccordion = () => useContext(AccordionContext);

// src/Accordion/Accordion.tsx
var Accordion = (_a) => {
  var _b = _a, {
    children,
    defaultExpanded = false,
    onChange,
    onAnimationEnd,
    lazyRenderDetails,
    extend,
    expanded,
    hideDivider
  } = _b, rest = __objRest(_b, [
    "children",
    "defaultExpanded",
    "onChange",
    "onAnimationEnd",
    "lazyRenderDetails",
    "extend",
    "expanded",
    "hideDivider"
  ]);
  const [isExpanded, setIsExpanded] = useControlled({
    defaultValue: defaultExpanded,
    value: expanded
  });
  const [accordionKey] = useState2(() => nanoid(8));
  const isControlled = typeof expanded === "boolean";
  const value = useMemo(() => {
    return {
      accordionKey,
      setIsExpanded,
      isExpanded,
      onChange,
      lazyRenderDetails,
      onAnimationEnd,
      isControlled
    };
  }, [
    accordionKey,
    isExpanded,
    setIsExpanded,
    onChange,
    lazyRenderDetails,
    onAnimationEnd,
    isControlled
  ]);
  return /* @__PURE__ */ React2.createElement(View, __spreadProps(__spreadValues({}, rest), {
    extend: [
      {
        extend: {
          condition: !hideDivider,
          style: {
            "& :not(:only-of-type) .react-accordion__divider:last-child": {
              display: "block"
            }
          }
        }
      },
      extend
    ]
  }), /* @__PURE__ */ React2.createElement(AccordionContext.Provider, {
    value
  }, children));
};

// src/AccordionSummary/AccordionSummary.tsx
import React5, { forwardRef as forwardRef2, useCallback as useCallback3, useEffect as useEffect3, useRef } from "react";
import { usePrevious } from "@volvo-cars/react-utils";
import { Flex, Icon, Inline } from "vcc-ui";

// src/AccordionController/AccordionController.tsx
import React3, {
  createContext as createContext2,
  useCallback as useCallback2,
  useContext as useContext2,
  useMemo as useMemo2,
  useState as useState4
} from "react";
import { createKeyboardNavigation } from "@volvo-cars/react-aria";

// src/utils/useMediaQuery.ts
import { useEffect, useState as useState3 } from "react";
function useMediaQuery(query) {
  const [state, setState] = useState3(false);
  useEffect(() => {
    if (!window.matchMedia)
      return;
    setState(window.matchMedia(query).matches);
    const listener = (mediaQueryEvent) => setState(mediaQueryEvent.matches);
    const mq = window.matchMedia(query);
    mq.addListener(listener);
    return () => {
      mq.removeListener(listener);
    };
  }, [query]);
  return state;
}

// src/AccordionController/AccordionController.tsx
var { useKeyboardNavigation, KeyboardNavigationProvider } = createKeyboardNavigation();
var AccordionControllerContext = createContext2(void 0);
var AccordionController = ({
  children,
  multiple = false
}) => {
  const [openAccordions, setOpenAccordions] = useState4(() => /* @__PURE__ */ new Set());
  const reducedMotion = useMediaQuery("(prefers-reduced-motion)");
  const updateOpenAccordions = useCallback2((accordionKey, add = true) => {
    if (!add) {
      setOpenAccordions((openAccordions2) => {
        openAccordions2.delete(accordionKey);
        return new Set(openAccordions2);
      });
      return;
    }
    if (multiple) {
      setOpenAccordions((openAccordions2) => new Set(openAccordions2.add(accordionKey)));
    } else {
      setOpenAccordions(/* @__PURE__ */ new Set([accordionKey]));
    }
  }, [multiple]);
  const value = useMemo2(() => {
    return {
      openAccordions,
      updateOpenAccordions,
      reducedMotion
    };
  }, [openAccordions, updateOpenAccordions, reducedMotion]);
  return /* @__PURE__ */ React3.createElement(AccordionControllerContext.Provider, {
    value
  }, /* @__PURE__ */ React3.createElement(KeyboardNavigationProvider, null, children));
};
var useAccordionController = () => useContext2(AccordionControllerContext);

// src/utils/ButtonDiv.tsx
import React4, { forwardRef } from "react";
import { Block } from "vcc-ui";
var ButtonDiv = forwardRef(function ButtonDiv2(_a, ref) {
  var _b = _a, { children, onClick, disabled, onKeyPress } = _b, rest = __objRest(_b, ["children", "onClick", "disabled", "onKeyPress"]);
  const handleKeyPress = (event) => {
    onKeyPress == null ? void 0 : onKeyPress(event);
    if (disabled)
      return;
    if ((event.key === "Enter" || event.key === " " || event.key === "Spacebar") && !disabled) {
      event.preventDefault();
      onClick == null ? void 0 : onClick(event);
    }
  };
  return /* @__PURE__ */ React4.createElement(Block, __spreadProps(__spreadValues({
    role: "button"
  }, rest), {
    ref,
    as: "div",
    onKeyPress: handleKeyPress,
    onClick,
    tabIndex: disabled ? -1 : 0
  }), children);
});

// src/utils/transition.ts
var transitionTimingFunction = "cubic-bezier(0.4, 0, 0.2, 1)";

// src/utils/useSummaryId.ts
import { useEffect as useEffect2, useState as useState5 } from "react";
var useSummaryId = () => {
  const { accordionKey } = useAccordion() || {};
  const [summaryId, setSummaryId] = useState5("");
  useEffect2(() => {
    if (accordionKey) {
      setSummaryId(accordionKey);
    }
  }, [accordionKey]);
  return summaryId;
};

// src/AccordionSummary/AccordionSummary.tsx
var AccordionSummary = forwardRef2(function AccordionSummary2(_a, ref) {
  var _b = _a, { children, onInteraction, iconAlignment = "top", extend } = _b, rest = __objRest(_b, ["children", "onInteraction", "iconAlignment", "extend"]);
  const { updateOpenAccordions, openAccordions } = useAccordionController() || {};
  const {
    accordionKey,
    setIsExpanded,
    isExpanded,
    onChange: onAccordionChange,
    isControlled
  } = useAccordion() || {};
  const openAccordionsSize = openAccordions == null ? void 0 : openAccordions.size;
  const previousExpandedState = usePrevious(!!isExpanded);
  const isInitialRender = useIsInitialRender();
  useEffect3(() => {
    if (isControlled || isInitialRender)
      return;
    if (isExpanded !== previousExpandedState) {
      onAccordionChange == null ? void 0 : onAccordionChange(!!isExpanded);
    }
  }, [
    onAccordionChange,
    isExpanded,
    isControlled,
    previousExpandedState,
    isInitialRender
  ]);
  const handleExpand = useCallback3((event) => {
    onInteraction == null ? void 0 : onInteraction({ event, expanded: !isExpanded });
    if (isControlled) {
      onAccordionChange == null ? void 0 : onAccordionChange(!isExpanded);
    }
    if (!updateOpenAccordions || !accordionKey) {
      setIsExpanded == null ? void 0 : setIsExpanded((isExpanded2) => !isExpanded2);
      return;
    }
    updateOpenAccordions(accordionKey, !isExpanded);
    setIsExpanded == null ? void 0 : setIsExpanded(!isExpanded);
  }, [
    updateOpenAccordions,
    accordionKey,
    setIsExpanded,
    isExpanded,
    onInteraction,
    isControlled,
    onAccordionChange
  ]);
  const isActive = !!(openAccordions == null ? void 0 : openAccordions.has(accordionKey || ""));
  useEffect3(() => {
    if (!setIsExpanded || !openAccordionsSize)
      return;
    setIsExpanded(isActive);
  }, [isActive, setIsExpanded, openAccordionsSize]);
  const summaryId = useSummaryId();
  const id = summaryId ? `${summaryId}-header` : void 0;
  const controls = summaryId ? `${summaryId}-content` : void 0;
  const keyboardNavigationProps = useKeyboardNavigation({
    ref,
    orientation: "vertical"
  });
  return /* @__PURE__ */ React5.createElement(ButtonDiv, __spreadProps(__spreadValues(__spreadValues({}, rest), keyboardNavigationProps), {
    extend: ({ theme: { color } }) => ({
      cursor: "pointer",
      border: "1px solid transparent",
      "&:focus": {
        outline: "none"
      },
      "&:focus-visible": {
        borderColor: color.foreground.primary
      }
    }),
    "aria-controls": controls,
    id,
    onClick: handleExpand,
    "aria-expanded": isExpanded
  }), /* @__PURE__ */ React5.createElement(Flex, {
    extend: [
      ({ theme: { baselineGrid } }) => ({
        flexDirection: "row",
        padding: `${2 * baselineGrid}px 0px`
      }),
      extend
    ]
  }, /* @__PURE__ */ React5.createElement(Flex, {
    extend: { flexGrow: 1 }
  }, children), /* @__PURE__ */ React5.createElement(Flex, {
    extend: ({ theme: { color } }) => ({
      width: 24,
      height: 24,
      color: color.foreground.primary,
      alignSelf: iconAlignment === "center" ? "center" : "auto"
    })
  }, /* @__PURE__ */ React5.createElement(Chevron, {
    direction: isExpanded ? "up" : "down"
  }))));
});
var Chevron = ({ direction }) => {
  const rotate = direction === "up" ? 180 : 0;
  return /* @__PURE__ */ React5.createElement(Inline, {
    extend: {
      speak: "none",
      display: "inline-block",
      height: "inherit",
      width: "inherit",
      transform: `rotate(${rotate || 0}deg)`,
      transformOrigin: "center",
      transition: `transform 300ms ${transitionTimingFunction}`
    }
  }, /* @__PURE__ */ React5.createElement(Icon, {
    type: "navigation-chevrondown-24"
  }));
};
var useIsInitialRender = () => {
  const isMountRef = useRef(true);
  useEffect3(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};

// src/AccordionAction/AccordionAction.tsx
import React6, { forwardRef as forwardRef3 } from "react";
import { View as View2 } from "vcc-ui";
var AccordionAction = forwardRef3(function AccordionAction2(_a, ref) {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React6.createElement(View2, __spreadProps(__spreadValues({}, rest), {
    ref,
    as: "div",
    onClick: (event) => event.stopPropagation(),
    onKeyPress: (event) => event.stopPropagation()
  }), children);
});

// src/AccordionDetails/AccordionDetails.tsx
import React8, { forwardRef as forwardRef4 } from "react";
import { Block as Block3, View as View3 } from "vcc-ui";

// src/utils/Expand.tsx
import React7, { memo, useCallback as useCallback4, useEffect as useEffect4, useRef as useRef2, useState as useState6 } from "react";
import { Block as Block2 } from "vcc-ui";
var Expand = memo(function InnerExpand(_a) {
  var _b = _a, {
    isExpanded,
    animateOpacity = false,
    unmountOnExit = false,
    duration = 300,
    onAnimationEnd,
    children,
    reducedMotion
  } = _b, rest = __objRest(_b, [
    "isExpanded",
    "animateOpacity",
    "unmountOnExit",
    "duration",
    "onAnimationEnd",
    "children",
    "reducedMotion"
  ]);
  const [height, setHeight] = useState6(isExpanded ? "auto" : "0px");
  const [isVisible, setIsVisible] = useState6(isExpanded);
  const [animateExpand, setAnimateExpand] = useState6(isExpanded);
  const [shouldMount, setShouldMount] = useState6(!unmountOnExit);
  const ref = useRef2(null);
  const entryTimer = useRef2();
  const leaveTimer = useRef2();
  const resetTimer = useRef2();
  duration = reducedMotion ? 0 : duration;
  const updateHeight = useCallback4(() => {
    setHeight(ref.current ? ref.current.offsetHeight + "px" : "0px");
  }, []);
  useEffect4(() => {
    if (isExpanded) {
      setShouldMount(true);
    }
  }, [isExpanded]);
  useEffect4(() => {
    if (!shouldMount)
      return;
    updateHeight();
    if (isExpanded) {
      setIsVisible(true);
    }
    entryTimer.current = window.setTimeout(() => {
      setAnimateExpand(isExpanded);
    }, duration ? 30 : 0);
    if (isExpanded) {
      resetTimer.current = window.setTimeout(() => {
        setHeight("auto");
      }, duration ? duration + 50 : 0);
    } else {
      leaveTimer.current = window.setTimeout(() => {
        setIsVisible(isExpanded);
        if (unmountOnExit) {
          setShouldMount(isExpanded);
        }
      }, duration / 1.5);
    }
    return () => {
      clearTimeout(entryTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(resetTimer.current);
    };
  }, [isExpanded, updateHeight, shouldMount, unmountOnExit, duration]);
  return /* @__PURE__ */ React7.createElement(Block2, {
    onTransitionEnd: (event) => {
      event.stopPropagation();
      onAnimationEnd == null ? void 0 : onAnimationEnd(isVisible);
    },
    extend: containerCSS({
      isVisible,
      animateExpand,
      height,
      animateOpacity,
      duration,
      reducedMotion
    })
  }, shouldMount ? /* @__PURE__ */ React7.createElement(Block2, __spreadValues({
    ref
  }, rest), children) : null);
});
var containerCSS = ({
  isVisible,
  animateExpand,
  height,
  animateOpacity,
  duration,
  reducedMotion
}) => ({
  padding: 0,
  margin: 0,
  height: 0,
  overflow: "hidden",
  visibility: isVisible ? "visible" : "hidden",
  transition: reducedMotion ? "" : `height ${duration}ms ${transitionTimingFunction}`,
  extend: [
    {
      condition: animateExpand,
      style: {
        visibility: "visible",
        height
      }
    },
    {
      condition: animateOpacity,
      style: {
        transition: reducedMotion ? "" : `height ${duration}ms ${transitionTimingFunction},opacity ${duration}ms ${transitionTimingFunction}`,
        opacity: animateExpand ? 1 : 0
      }
    }
  ]
});

// src/AccordionDetails/AccordionDetails.tsx
var AccordionDetails = forwardRef4(function AccordionDetails2(_a, ref) {
  var _b = _a, { children, extend } = _b, rest = __objRest(_b, ["children", "extend"]);
  const { isExpanded, lazyRenderDetails, onAnimationEnd } = useAccordion() || {};
  const summaryId = useSummaryId();
  const { reducedMotion } = useAccordionController() || {};
  const id = summaryId ? `${summaryId}-content` : void 0;
  const labelledBy = summaryId ? `${summaryId}-header` : void 0;
  return /* @__PURE__ */ React8.createElement(View3, __spreadProps(__spreadValues({}, rest), {
    extend: [{ border: "1px solid transparent" }, extend],
    ref,
    as: "div",
    id,
    "aria-labelledby": labelledBy
  }), /* @__PURE__ */ React8.createElement(Expand, {
    isExpanded: !!isExpanded,
    unmountOnExit: lazyRenderDetails,
    onAnimationEnd,
    animateOpacity: true,
    reducedMotion,
    extend: ({ theme: { baselineGrid } }) => ({
      paddingBottom: 2 * baselineGrid
    })
  }, children), /* @__PURE__ */ React8.createElement(Block3, {
    className: "react-accordion__divider",
    extend: ({ theme: { color } }) => ({
      height: 1,
      background: color.ornament.divider,
      display: "none"
    })
  }));
});
export {
  Accordion,
  AccordionAction,
  AccordionContext,
  AccordionController,
  AccordionDetails,
  AccordionSummary,
  Expand,
  useAccordionController,
  useMediaQuery
};
